import { viewFromCursor } from '@/modules/upsell/application/upsell-sequence';
import { resolveDownloadAppComponent } from '@/services/download-app-by-brand';

export const getUpsellProductType = (state) => state.productType;

export const getUpsellPricingModel = (state) => state.pricingModel;

export const getUpsellTourId = (state) => state.tourId;

export const getUpsellProduct = (state) => ({
  productType: state.productType,
  pricingModel: state.pricingModel,
  tourId: state.tourId,
});

export const getSequenceSnapshot = (state) => state.snapshot;

export const getSequenceInput = (state) => state.snapshot?.sequence ?? null;

export const getCursor = (state) => state.snapshot?.cursor ?? null;

export const getCursorView = (state) =>
  viewFromCursor(state.snapshot?.cursor ?? null, state.snapshot?.currentSequenceTree ?? null);

export const getUpsellOverlay = (state) => state.overlay;

export const getRenderedComponent = (state, _getters, _rootState, rootGetters) => {
  if (state.overlay) return state.overlay;
  const cursor = state.snapshot?.cursor;
  if (!cursor) return '';
  if (cursor.kind === 'completed') {
    return resolveDownloadAppComponent(rootGetters['brand/getBrand']);
  }
  const view = viewFromCursor(cursor, state.snapshot?.currentSequenceTree ?? null);
  return view?.componentName ?? '';
};

export const getIsSequenceCompleted = (state) => state.snapshot?.cursor?.kind === 'completed';

export const getSequenceLength = (state) => state.snapshot?.progressTotal ?? 0;

export const getProgressIndex = (state) => state.snapshot?.progressIndex ?? 0;
